import React from 'react';
import { KOSTEN_ARTEN, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { assignIdsToStruc } from 'src/utils/helper';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { VNTreeStructureAbschluss } from '../default-content/abschluss-seite/VNTreeStructureAbschluss';
import { VNTreeStructureProjektDaten } from '../default-content/projekt-daten/VNTreeStructureProjektDaten';
import { VNTreeStructureWichtigeHinweis } from '../default-content/wichtige-hinweise/VNTreeStructureWichtigeHinweis';
import { VNTreeStructureErklaerungen } from './erklaerungen/VNTreeStructureErklaerungen';
import { VNTreeStructureFinanzierungsPlan } from './finanzierung-plan/VNTreeStructureFinanzierungPlan';

export const VNTreeStructureDefault = (application: any, allKostenArtZuAntrag: any) => {
	let treeNodes: TreeNodeType[] = [
		...VNTreeStructureWichtigeHinweis(application),
		// Projekt Daten
		...VNTreeStructureProjektDaten(application),
		// Kosten
		...PersonalKostenStructure(application, allKostenArtZuAntrag),
		...SachKostenStructure(application, allKostenArtZuAntrag),
		...InvestitionKostenStructure(application, allKostenArtZuAntrag),
		...ReiseKostenStructure(application, allKostenArtZuAntrag),
		// Eigenmittel
		...EigenmittelStructure(application, allKostenArtZuAntrag),
		// Finanzierungsplan
		...VNTreeStructureFinanzierungsPlan(application),
		// Erklärungen
		...VNTreeStructureErklaerungen(application),
		// Abschluss
		...VNTreeStructureAbschluss(application),
	];

	return assignIdsToStruc(treeNodes);
};

const PersonalKostenStructure = (_application: any, kostenArtZuAntrag: any) => {
	if (kostenArtZuAntrag.includes(KOSTEN_ARTEN.Personalkosten)) {
		return [
			{
				label: 'Personalkosten',
				content: <ApplicationHeading title='Personalkosten' description={PLATZHALTER_TEXT} />,
			},
			{
				label: 'Personalkosten Übersicht',
				content: <ApplicationHeading title='Personalkosten Übersicht' description={PLATZHALTER_TEXT} />,
			},
		];
	}

	return [];
};

const SachKostenStructure = (_application: any, kostenArtZuAntrag: any) => {
	if (kostenArtZuAntrag.includes(KOSTEN_ARTEN.Sachkosten)) {
		return [
			{
				label: 'Sachkosten',
				content: <ApplicationHeading title='Sachkosten' description={PLATZHALTER_TEXT} />,
			},
			{
				label: 'Sachkosten Übersicht',
				content: <ApplicationHeading title='Sachkosten Übersicht' description={PLATZHALTER_TEXT} />,
			},
		];
	}

	return [];
};

const InvestitionKostenStructure = (_application: any, kostenArtZuAntrag: any) => {
	if (kostenArtZuAntrag.includes(KOSTEN_ARTEN.Investitionskosten)) {
		return [
			{
				label: 'Investitionskosten',
				content: <ApplicationHeading title='Investitionskosten' description={PLATZHALTER_TEXT} />,
			},
			{
				label: 'Investitionskosten Übersicht',
				content: <ApplicationHeading title='Investitionskosten Übersicht' description={PLATZHALTER_TEXT} />,
			},
		];
	}

	return [];
};
const ReiseKostenStructure = (_application: any, kostenArtZuAntrag: any) => {
	if (kostenArtZuAntrag.includes(KOSTEN_ARTEN.Reisekosten)) {
		return [
			{
				label: 'Reisekosten',
				content: <ApplicationHeading title='Reisekosten' description={PLATZHALTER_TEXT} />,
			},
			{
				label: 'Reisekosten Übersicht',
				content: <ApplicationHeading title='Reisekosten Übersicht' description={PLATZHALTER_TEXT} />,
			},
		];
	}

	return [];
};

const EigenmittelStructure = (_application: any, kostenArtZuAntrag: any) => {
	if (kostenArtZuAntrag.includes(KOSTEN_ARTEN.Eigenmittel)) {
		return [
			{
				label: 'Eigen- und Drittmittel',
				content: <ApplicationHeading title='Eigen- und Drittmittel' description={PLATZHALTER_TEXT} />,
			},

			{
				label: 'Eigen- und Drittmittel Übersicht',
				content: <ApplicationHeading title='Eigen- und Drittmittel Übersicht' description={PLATZHALTER_TEXT} />,
			},
		];
	}

	return [];
};
